<template>
      <div v-if="getRetoucherTime(day[1], day[0], item[0]).length > 0"
           :id="day[0]+item[0]"
           class="uk-grid uk-grid-collapse uk-grid-divider">

        <div v-if="currentWorkerForMinuteEmployment !== '' && minutesEmploymentDataForUser" class="tm-scheduletable-dropdown-box0">
          <!--шапка0-->
          <div class="tm-scheduletable-dropdown-list-head">
            <div class="uk-grid uk-grid-collapse uk-flex-middle">
              <div style="width: 55px;">
                <div class="tm-scheduletable-dropdown-list-cell" :data-uk-tooltip="'title:'+  local_page_keys.schedule_tooltip_minute_employment">
                  <md-icon>schedule</md-icon>
                </div>
              </div>
              <div class="uk-width-expand">
                <div class="tm-scheduletable-dropdown-list-cell uk-text-center">
                  <!--{{ currentWorkerForMinuteEmployment }}-->
<!--                  <span v-if="minutesEmploymentDataForUser['minutesEmployment']">-->
<!--                    (+{{ minutesEmploymentDataForUser['plusCount']}}/-{{ minutesEmploymentDataForUser['minusCount'] }})-->
<!--                  </span>-->
                </div>
              </div>
              <div class="tm-scheduletable-dropdown-list-width-small">
                <div class="tm-scheduletable-dropdown-list-cell pointer" data-uk-tooltip="Закрыть" @click="closeCurrentWorkerForMinuteEmployment(ordersDelay[item[0]][day[0]])">
                  <md-icon>close</md-icon>
                </div>
              </div>
            </div>
          </div>
          <!--таблица0-->
          <div class="uk-panel-scrollable tm-scheduletable-dropdown-list-scrollable" >
<!--            <div v-if="loadingMinuteEmployment"-->
<!--                 class="uk-height-1-1 uk-flex uk-flex-middle uk-flex-center ">-->
<!--              <v-progress-circular :width="1" :size="60" indeterminate style="color: forestgreen"></v-progress-circular>-->
<!--            </div>-->
<!--            <div v-else class="">-->
              <div v-if="minutesEmploymentDataForUser['empty']" class="tm-scheduletable-dropdown-list-cell">
                {{ local_page_keys.button_no_data }}
              </div>
              <template v-else>
                <div v-for="(minute,index) in minutesEmploymentDataForUser['minutesEmployment']"
                     :key="index"
                     class="uk-grid uk-grid-collapse uk-flex-middle tm-scheduletable-dropdown-list">
                  <div style="width: 55px;">
                    <div class="tm-scheduletable-dropdown-list-cell uk-text-bold" style="display: block;"
                         :class="getClassMinutesEmployment(minute)">
                      {{ index }}
                    </div>
                  </div>
                  <div class="uk-width-expand"></div>
                  <div class="tm-scheduletable-dropdown-list-width-small">
                    <!--                    <div class="tm-scheduletable-dropdown-list-cell tm-scheduletable-dropdown-list-cell-bg uk-text-bold"-->
                    <!--                         :class="{'tm-scheduletable-dropdown-list-cell-bg-red': minute === '-' }">-->
                    <!--                      {{ minute }}-->
                    <!--                    </div>-->
                  </div>
                </div>
              </template>
            </div>
<!--          </div>-->
        </div>

        <div class="tm-scheduletable-dropdown-box1">
          <div>
            <!--шапка1-->
            <div class="tm-scheduletable-dropdown-list-head">
              <div class="uk-grid uk-grid-collapse">
                <div class="tm-scheduletable-dropdown-list-width-small"></div>
                <div class="uk-width-expand">
                  <div class="tm-scheduletable-dropdown-list-cell uk-text-left" data-uk-tooltip="ФИО про-ретушера">
                    Pro-retoucher
                  </div>
                </div>
                <template v-if="isPast(day[0], item[0])">
                  <div class="tm-scheduletable-dropdown-list-width-small">
                    <div class="tm-scheduletable-dropdown-list-cell"
                         data-uk-tooltip="Фактическое кол-во заказов, выполненное про-ретушером">
                      <i class="md-icon tm-scheduletable-icon">numbers</i>
                    </div>
                  </div>
                  <!--                            <div class="tm-scheduletable-dropdown-list-width-small">-->
                  <!--                              <div class="tm-scheduletable-dropdown-list-cell"-->
                  <!--                                   data-uk-tooltip="Кол-во минут простоя у про-ретушера">-->
                  <!--                                <i class="md-icon tm-scheduletable-icon">schedule</i>-->
                  <!--                              </div>-->
                  <!--                            </div>-->
                  <div class="tm-scheduletable-dropdown-list-width-small">
                    <div class="tm-scheduletable-dropdown-list-cell"
                         :data-uk-tooltip="local_page_keys.schedule_tooltip_minute_in_schedule">
                      <i class="md-icon tm-scheduletable-icon">battery_charging_full</i>
                    </div>
                  </div>
                </template>
              </div>
            </div>
            <!--таблица1-->
            <div class="uk-panel-scrollable tm-scheduletable-dropdown-list-scrollable">
              <div v-if="loadingMinuteEmployment"
                   class="uk-height-1-1 uk-flex uk-flex-middle uk-flex-center uk-animation-fade">
                <v-progress-circular :width="1" :size="60" indeterminate style="color: forestgreen"></v-progress-circular>
              </div>
              <div v-else class="uk-animation-fade">
                <div v-for="worker in getRetoucherTime(day[1], day[0], item[0])" :key="worker.id">
                  <ScheduleTableProRetoucherItem
                      v-if="worker['name'] !== '' && worker['email'] !==''"
                      :worker="worker"
                      :day="day"
                      :item="item"
                      :timeControl="timeControl"
                      :local_page_keys="local_page_keys"
                      :keyLockIsChecked="keyLockIsChecked"
                      :keyLockIstoSet="keyLockIstoSet"
                      :showDialog="showDialog"
                      :isProRetoucher="isProRetoucher"
                      :getMinuteEmployment="getMinuteEmployment"
                      :minutesEmploymentData="minutesEmploymentData"
                  ></ScheduleTableProRetoucherItem>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-if="ordersDelay[item[0]][day[0]] && Object.entries(ordersDelay[item[0]][day[0]]).length" class="tm-scheduletable-dropdown-box2">
          <!--шапка2-->
          <div class="tm-scheduletable-dropdown-list-head">
            <div class="uk-grid uk-grid-collapse">
              <div class="uk-width-expand">
                <div class="tm-scheduletable-dropdown-list-cell uk-text-left" :data-uk-tooltip="local_page_keys.schedule_tooltip_shift_with_delay">
                  {{ local_page_keys.schedule_shift_with_delay }}
                </div>
              </div>
              <div class="tm-scheduletable-dropdown-list-width-small">
                <div class="tm-scheduletable-dropdown-list-cell" data-uk-tooltip="Кол-во минут ожидания клиентами">
                  <i class="md-icon tm-scheduletable-icon">schedule</i>
                </div>
              </div>
              <div class="tm-scheduletable-dropdown-list-width-small">
                <div class="tm-scheduletable-dropdown-list-cell" :data-uk-tooltip="local_page_keys.schedule_tooltip_not_taken_into_work">
                  <i class="md-icon tm-scheduletable-icon">numbers</i>
                </div>
              </div>
            </div>
          </div>
          <!--таблица2-->
          <div class="uk-panel-scrollable tm-scheduletable-dropdown-list-scrollable">
            <div v-for="(delay) in ordersDelay[item[0]][day[0]]" :key="delay.id">
              <div @click="toggleDelay(delay,item[0],day[0])">
                <div class="uk-grid uk-grid-collapse uk-flex-middle tm-scheduletable-dropdown-list"
                     :class="{'tm-active': delay.id  ===  selectedDelay.id }" style="cursor: pointer">
                  <div class="uk-width-expand uk-text-left">
                    <div
                        class="tm-scheduletable-dropdown-list-cell tm-scheduletable-dropdown-list-cell-bg uk-text-bold">
                      {{ delay.notification_time.split(" ")[1].slice(0, 5) }}
                    </div>
                  </div>
                  <div class="tm-scheduletable-dropdown-list-width-small">
                    <div
                        class="tm-scheduletable-dropdown-list-cell tm-scheduletable-dropdown-list-cell-bg uk-text-bold">
                      {{ delay.time_delay }}
                    </div>
                  </div>
                  <div class="tm-scheduletable-dropdown-list-width-small">
                    <div
                        class="tm-scheduletable-dropdown-list-cell tm-scheduletable-dropdown-list-cell-bg uk-text-bold">
                      {{ delay.number_delay_orders }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="ordersDelay[item[0]][day[0]] && Object.entries(ordersDelay[item[0]][day[0]]).length" class="tm-scheduletable-dropdown-box3">
          <!--шапка3-->
          <div class="tm-scheduletable-dropdown-list-head">
            <div class="uk-grid uk-grid-collapse">
              <div class="uk-width-expand">
                <div class="tm-scheduletable-dropdown-list-cell uk-text-left" data-uk-tooltip="Номер заказа">
                  Order #
                </div>
              </div>
              <div class="tm-scheduletable-dropdown-list-width-small">
                <div class="tm-scheduletable-dropdown-list-cell" data-uk-tooltip="Кол-во минут ожидания клиентом">
                  <i class="md-icon tm-scheduletable-icon">schedule</i>
                </div>
              </div>
            </div>
          </div>
          <!--таблица3-->
          <div class="loader-hide" :id="'delay-loader-'+day[0]+item[0]">
            <v-progress-circular :width="2" :size="20" indeterminate style="color: forestgreen"/>
          </div>
          <div v-if="!isDelayLoading">
            <div v-if="selectedDelay.delay_json !== null"
                 class="uk-panel-scrollable tm-scheduletable-dropdown-list-scrollable">
              <div v-for="delayJson in JSON.parse(selectedDelay.delay_json)" :key="delayJson.order_id">
                <div @click="openOrder(delayJson.order_id)"
                     class="uk-grid uk-grid-collapse uk-flex-middle tm-scheduletable-dropdown-list"
                     style="cursor: pointer;">
                  <div class="uk-width-expand uk-text-left">
                    <div
                        class="tm-scheduletable-dropdown-list-cell tm-scheduletable-dropdown-list-cell-bg uk-text-bold">
                      {{ delayJson.order_id }}
                    </div>
                  </div>
                  <div class="tm-scheduletable-dropdown-list-width-small">
                    <div
                        class="tm-scheduletable-dropdown-list-cell tm-scheduletable-dropdown-list-cell-bg uk-text-bold">
                      {{ delayJson.minutes_in_work }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-else>{{ local_page_keys.button_no_data }}</div>
          </div>
        </div>
      </div>
      <div v-else class="uk-padding-xsmall uk-text-center">No Data</div>
</template>

<script>
import ScheduleTableProRetoucherItem from "./ScheduleTableProRetoucherItem.vue";

export default {
  name: "ScheduleTableProRetoucherTooltipBlock",
  components: {ScheduleTableProRetoucherItem},
  props: {
    isPast: {
      require: true
    },
    closeCurrentWorkerForMinuteEmployment: {
      require: true
    },
    isDelayLoading: {
      require: true
    },
    selectedDelay: {
      require: true
    },
    getRetoucherTime: {
      type: Function,
      require: true
    },
    ordersDelay: {
      require: true
    },
    currentWorkerForMinuteEmployment: {
      type: String,
      require: true
    },
    loadingMinuteEmployment: {
      require: true
    },
    minutesEmploymentDataForUser: {
      require: true
    },
    keyLockIstoSet: {
      type: Boolean,
      require: true
    },
    showDialog: {
      type: Function,
      require: true
    },
    isProRetoucher: {
      type: Function,
      require: true
    },
    local_page_keys: {
      type: Object,
      require: true
    },
    timeControl: {
      type: Object,
      require: true
    },
    keyLockIsChecked: {
      type: Object,
      require: true
    },
    day: {
      type: Array,
      require: true
    },
    item: {
      type: Array,
      require: true
    },
    getMinuteEmployment: {
      type: Function,
      require: true
    },
    minutesEmploymentData: {
      require: true
    },
    openOrder: {
      type: Function,
      require: true
    },
    toggleDelay:{
      require: true
    },
    retoucher:{
      //type: String,
      require: true
    }
  },
  data() {
    return {}
  },
  methods: {
    getClassMinutesEmployment(item) {
      if (item.pause)
        return  'tm-scheduletable-dropdown-list-cell-bg-gray';

      return (item.sign === '-') ? 'tm-scheduletable-dropdown-list-cell-bg-red' : 'tm-scheduletable-dropdown-list-cell-bg';
    }
  }
}
</script>
<style scoped></style>